export default __webpack_public_path__ + "static/media/neurotoxins.a81a481d.pdf";